import { render, staticRenderFns } from "./AdminEmailsMailing.vue?vue&type=template&id=525b509a"
import script from "./AdminEmailsMailing.vue?vue&type=script&lang=js"
export * from "./AdminEmailsMailing.vue?vue&type=script&lang=js"
import style0 from "./AdminEmailsMailing.vue?vue&type=style&index=0&id=525b509a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports